/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import { Button, Confirm } from 'semantic-ui-react'
import { t } from 'shared'

// TODO for Kamil
export const FormButtonWithConfirmation = ({ confirmButtonText, content, message, ...props }: any) => {
  const [showDialog, setShowDialog] = useState(false)

  return (
    <>
      <Button
        primary
        size="large"
        content={content}
        onClick={(e) => {
          e.preventDefault()
          setShowDialog(true)
        }}
      />
      <Confirm
        open={showDialog}
        content={message}
        cancelButton={<Button primary basic content={t('verbs.cancel')} />}
        confirmButton={<Button negative content={confirmButtonText} />}
        onCancel={() => setShowDialog(false)}
        onConfirm={() => {
          props.form.submit()
          // Always hide the dialog right away to reveal the Form and the
          // loading state it enters upon submit().
          // If we want to hide the dialog only after submit() is settled,
          // we'd have to indicate the loading state in the dialog itself.
          setShowDialog(false)
        }}
      />
    </>
  )
}
